<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item label="医生名字" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['sex']" :trigger-change="true" dictCode="sex" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['idCard']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所在地区" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-area-linkage type="cascader" v-decorator="['cityId']" placeholder="请输入省市区"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="医疗机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['hospital']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
                      <a-form-item label="职称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-decorator="['title']" ></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                                <a-form-item label="头衔" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                  <a-input v-decorator="['master']" ></a-input>
                                </a-form-item>
                              </a-col>

          <a-col :span="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="科室"
              hasFeedback
            >
              <a-row :gutter="16" >
                <a-col :span="4">

                </a-col>
                <a-col :span="20">
                  <a-checkbox-group />
                </a-col>
              </a-row>

            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="擅长"
              hasFeedback
            >

              <a-input v-decorator="['good']" ></a-input>

            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="个人简介"
              hasFeedback
            >
              <a-textarea :rows="5"  placeholder="..." id="describe"/>
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import JDate from '@comp/jeecg/JDate'
import JAreaLinkage from '@comp/jeecg/JAreaLinkage'

export default {
  name: 'DoctorForm',
  components: {
    JFormContainer,
    JDate,
    JImageUpload,
    JDictSelectTag,
    JAreaLinkage,

  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: ()=>{},
      required: false
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        mobile: {
          rules: [
            { required: true, message: '请输入医生手机号!'},
          ]
        },
      },
      url: {
        add: "/doctor/doctor/add",
        // edit: "/doctor/doctor/editInfo",
        // edit: "/doctor/doctor/edit",
        // queryById: "/doctor/doctor/queryById"
      }
    }
  },
  computed: {
    formDisabled(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return true
        }
      }
      return false
    }
  },
  created () {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData();
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'name','mobile','headImg','hostpital','title','department','sex','idcard','provinceId','cityId','openid','wxAccountId','qrCode','deviceToken','status','introduction',
        'good','hospital','idCard','provinceId','provinceName','cityId','cityName','departmentName','departmentId','beGoodAt','cityInfo','department','parentId','img','sort','list','level','status'))
        // this.form.setFieldsValue(pick(this.model,'name','mobile','headImg','hostpital','title','department','sex','idcard','provinceId','cityId','openid','wxAccountId','qrCode','deviceToken','status','businessType'))
      })
    },
    //渲染流程表单数据
    showFlowData(){
      if(this.formBpm === true){
        let params = {id:this.formData.dataId};
        getAction(this.url.queryById,params).then((res)=>{
          if(res.success){
            this.edit (res.result);
          }
        });
      }
    },
    submitForm () {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if(!this.model.id){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          console.log("表单提交数据",formData)
          httpAction(httpurl,formData,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'name','mobile','headImg','hostpital','title','department','sex','idcard','provinceId','cityId','openid','wxAccountId','qrCode','deviceToken','status','businessType'))
    },
  }
}
</script>